export default __webpack_public_path__ + "static/media/google-maps.a8ce1ed8.png";